import { motion } from 'framer-motion';
import { Building2, Home, Hammer, ClipboardList, PenTool, Sofa, Map, Box, Boxes, Factory, Mountain, Leaf ,BrickWall,KeyRound} from 'lucide-react';

const iconMap = {
  Building2,
  Home,
  Hammer,
  ClipboardList,
  PenTool,
  Sofa,
  Map,
  Box,
  Boxes,
  Factory,
  Mountain,
  Leaf,
  BrickWall,
  KeyRound,
};

export const ServicesSection = ({ services, companyName, loading }) => {
  if (loading) {
    return (
      <section id="services" className="py-24 md:py-32 bg-obsidian-paper">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="animate-pulse space-y-8">
            <div className="h-8 bg-obsidian-subtle w-48"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-48 bg-obsidian-subtle"></div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-obsidian-paper noise-overlay"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gold" />
            <span className="text-gold text-xs uppercase tracking-[0.2em]">What We Offer</span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white">
            Our <span className="text-primary">Services</span>
          </h2>
          <p className="text-gray-400 mt-4 max-w-2xl">
            Comprehensive solutions tailored to your vision, delivered with excellence by {companyName}.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Building2;
            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group bg-obsidian border border-white/5 p-8 hover:border-gold/30 transition-colors"
                data-testid={`service-card-${index}`}
              >
                <div className="w-14 h-14 bg-primary/20 flex items-center justify-center mb-6 group-hover:bg-primary transition-colors">
                  <IconComponent className="w-7 h-7 text-gold group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-heading text-xl font-semibold text-white mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {service.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {services.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No services available for this company.
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;
